(function ($, Drupal) {
  if ($(".taxonomy-menu").length) {
    let taxonomyMenu = $(".taxonomy-menu");
    let taxMenuPlaceholder = $(".taxonomy-menu-placeholder");
    let taxonomyMenuHeight = taxonomyMenu.outerHeight();
    let taxonomyMenuDistance;

    let shopArray = Array.from($(".shop-category-section[id]"));
    let shopIds = shopArray.map((element) => element.id);

    let taxonomyMenuArray = Array.from($(".taxonomy-menu a[href^='#']"));
    let taxonomyElements = taxonomyMenuArray.map((element) =>
      element.innerHTML.split(" ").join("-").toLowerCase()
    );

    taxonomyElements.forEach((element) => {
      if (!shopIds.includes(element)) {
        $(`.taxonomy-menu a[href="#${element}"]`)
          .parents(".views-row")
          .remove();
      }
    });

    if (window.matchMedia("(max-width: 768px)").matches) {
      taxonomyMenuDistance = taxonomyMenu.offset().top + 26 - 65;
    } else {
      taxonomyMenuDistance = taxonomyMenu.offset().top + 26;
    }
    taxMenuPlaceholder.css("height", taxonomyMenuHeight);

    let prevScrollPos = $(window).scrollTop();
    // Initialize scrollPos with the previous scroll position
    let scrollPos = prevScrollPos;

    $(window).scroll(function () {
      scrollPos = $(window).scrollTop();

      if (scrollPos >= taxonomyMenuDistance) {
        taxonomyMenu.addClass("sticky");
      } else {
        taxonomyMenu.removeClass("sticky");
      }

      // When scrolling down remove first active element to avoid duplication
      if (scrollPos > prevScrollPos) {
        let activeElements = $(".taxonomy-menu .views-row a.active");
        if (activeElements.length > 1) {
          activeElements.not(":last").removeClass("active");
        }
      }
      // When scrolling up remove second active element to avoid duplication
      else if (scrollPos < prevScrollPos) {
        let activeElements = $(".taxonomy-menu .views-row a.active");
        //if user scrolled up - remove last
        if (activeElements.length > 1 && !clicked) {
          activeElements.last().removeClass("active");
        } else if (activeElements.length > 1 && clicked) {
          //if user clicked remove class from the element before clicked element
          activeElements.first().removeClass("active");
        }
      }

      // Update the previous scroll position
      prevScrollPos = scrollPos;
    });

    //flag for checking if user clicked or scrolled - when user clicked - true, when scrolled - false
    let clicked = false;

    $(".taxonomy-menu").on("click", 'a[href^="#"]', function (event) {
      event.preventDefault();
      clicked = true;
      let clickedElement = this;
      $("html, body").animate(
        {
          scrollTop:
            $($.attr(this, "href")).offset().top - 26 - taxonomyMenuHeight - 20,
        },
        500,
        function () {
          setTimeout(function () {
            // Toggle flag
            clicked = false;
            // if user clicked remove all but clickedElement
            $(clickedElement).addClass("active");
            $(".taxonomy-menu a[href^='#']")
              .not(clickedElement)
              .removeClass("active");
          }, 1500);
        }
      );
    });

    let toolbarHeight = taxonomyMenuHeight + 65 + 44;
    let rootMargString = `${-toolbarHeight}px 0px -500px 0px`;

    let options = {
      root: null,
      rootMargin: rootMargString,
      threshold: 0,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const id = entry.target.getAttribute("id");
        if (entry.intersectionRatio > 0) {
          $(`.taxonomy-menu .views-row a[href="#${id}"]`).addClass("active");
        } else {
          $(`.taxonomy-menu .views-row a[href="#${id}"]`).removeClass("active");
        }
      });
    }, options);

    document
      .querySelectorAll(".shop-category-section[id]")
      .forEach((section) => {
        observer.observe(section);
      });
  }
})(jQuery, Drupal);
